//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @author Rico
import baseFrom from "./baseForm";
import ThirdPartyLogin from "../ThirdPartyLogin.vue";
import { isMicroMessenger } from "@/utils/is";

export default {
  components: {
    ThirdPartyLogin,
  },
  extends: baseFrom,
  created() {
    // 微信下不显示 第三方登录
    this.isWeChat = isMicroMessenger();
    // this.isWeChat = true;
  },
  data() {
    return {
      action: "password-login",
      form: {
        account: "",
        password: "",
      },
      isWeChat: false,
    };
  },
};
